'use client';
import React from 'react';
function Table({ children, cols }) {
    return (
        <table style={{ '--cols': cols }}>
            {children}
        </table>
    )
}
export default Table